import moment from 'moment';
import mtz from 'moment-timezone';

const DEFAULT_DATE_TIME_FORMAT = 'MM/DD/YYYY';

function toUTC(value, format = null) {
  const timezone = mtz.tz.guess();
  const date = mtz.tz(value, 'YYYY-MM-DD HH:mm:ss', timezone);
  return format ? date.format(format) : date.toISOString();
}

function toLocalDate(value) {
  return moment(value).local();
}

function formatDate(value, format = DEFAULT_DATE_TIME_FORMAT) {
  return moment(value).format(format);
}

function toFormattedLocalDate(value, format) {
  return formatDate(toLocalDate(value), format);
}

function toFormattedLocalDateAnswer(value, format) {
  return moment
    .utc(value)
    .local()
    .format(format);
}

function compareDates(date1, date2) {
  return moment(date1).valueOf() > moment(date2).valueOf() ? -1 : 1;
}

export { toUTC, toLocalDate, formatDate, toFormattedLocalDate, toFormattedLocalDateAnswer, compareDates, DEFAULT_DATE_TIME_FORMAT };
